import actions from "actions";
import constants from "constants";
import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { push } from "redux-router";
import storage from "services/storage.js";
import PreviousWebinarItem from "./PreviousWebinarItem";
import PreviousWebinarsView from "./PreviousWebinarsView";

const { subscribeWebinarSaga } = actions;

const { PREVIOUS_WEBINARS } = constants;

class PreviousWebinars extends React.Component {
  constructor(props) {
    super(props);
    this.token = storage.getSessionData().session.token;
  }

  webinars = () =>
    this.props.webinars.map((webinar) => {
      return (
        <PreviousWebinarItem
          key={webinar.id}
          webinar={webinar}
          token={this.token}
          subscriptionAction={() => this.subscriptionAction(webinar)}
        />
      );
    });

  filteredWebinars = () =>
    this.props.webinars.map((webinar) => {
      return webinar.vimeo_url ? (
        <PreviousWebinarItem
          key={webinar.id}
          webinar={webinar}
          token={this.token}
          subscriptionAction={() => this.subscriptionAction(webinar)}
        />
      ) : null;
    });

  subscriptionAction = (webinar) => {
    if (!webinar.subscription_id && webinar.webinar_type !== "recorded")
      this.props.subscribeWebinar(webinar);
    if (webinar.webinar_type === "audio")
      return this.props.showAudioWebinar(this.props.groupId, webinar.id);
    this.props.showOnlineWebinar(this.props.groupId, webinar.id);
  };

  render() {
    return (
      <PreviousWebinarsView
        nextPage={this.props.nextPage}
        webinars={
          this.props.user && this.props.user.user_type != "sponsor"
            ? this.webinars()
            : this.filteredWebinars()
        }
        pagination={this.props.pages > this.props.page}
        count={this.props.count}
        sponsor={this.props.sponsor}
        sponsors={this.props.sponsors}
        onFilterChange={this.props.onFilterChange}
      />
    );
  }
}

PreviousWebinars.propTypes = {
  webinars: PropTypes.array,
  subscribeWebinar: PropTypes.func,
};

const mapStateToProps = (state) => ({
  pages: state.webinars[PREVIOUS_WEBINARS].pages,
  user: state.users.user,
});

const mapDispatchToProps = (dispatch) => ({
  subscribeWebinar: (webinar) => dispatch(subscribeWebinarSaga(webinar)),
  showOnlineWebinar: (groupId, webinarId) =>
    dispatch(push(`/groups/${groupId}/webinars/${webinarId}`)),
  showAudioWebinar: (groupId, webinarId) =>
    dispatch(push(`/groups/${groupId}/webinars/${webinarId}/audio`)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviousWebinars);



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/Webinars/Recorded/PreviousWebinars.jsx